export const QuestionTypes = {
  "MCQ":'mcq',
  "MMCQ":'mmcq',
  "ONE_WORD":"oneword",
  "FILL_UP":"fillup",
  "CORRECT_STATEMENT":"correctstatement",
  "ASSERTION_REASONING":"assertion-reasoning",
  "DESCRIPTIVE":"descriptive"
}